import { formatDate } from '@/utils/date'
import { useMemo, useState } from 'react'

const DocumentSelectionDialog = ({ documents, suggestionTabs, tabIdx, setTabIdx, addDocumentsToTab }) => {
    
    const selectedTab = useMemo(() => suggestionTabs[tabIdx] || {}, [tabIdx, suggestionTabs])
    
    const filteredDocuments = useMemo(() => documents
        .filter(d => !selectedTab.documents.some(td => td.id === d.id)), [documents, selectedTab])
    
    const [markedDocuments, setMarkedDocuments] = useState([])
    
    return (
        <div className="DocumentSelectionDialog absolute w-full h-full top-0 left-0 bg-black/50
            flex items-center justify-center">
            <div className=" flex flex-col bg-base-200 w-3/4 h-1/2 rounded-lg shadow-lg">
                <h4 className="text-lg border-b border-base-100 p-4 mb-4">
                    Add to Suggested Tab
                    <div className="-mt-1 text-sm text-slate-400">
                        Selected documents will be added to tab "{selectedTab.name}"
                    </div>
                </h4>
                <div className="overflow-auto rounded px-4 max-h-auto flex-1">
                    <table className="table table-sm table-bordered table-zebra table-pin-rows bg-base-100">
                        <thead>
                            <tr>
                                <th></th>
                                <th>Document</th>
                                <th>Instrument Type</th>
                                <th>Instrument Date</th>
                                <th>Grantor</th>
                                <th>Grantee</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredDocuments.map(d => <tr key={d.id}>
                                <td>
                                    <input
                                        type="checkbox"
                                        className="checkbox checkbox-sm"
                                        checked={markedDocuments.includes(d.id)}
                                        onChange={evt => {
                                            if (evt.target.checked)
                                                setMarkedDocuments(prev => [...prev, d.id])
                                            else
                                                setMarkedDocuments(prev => prev.filter(id => id !== d.id))
                                        }} />
                                </td>
                                <td><span className="line-clamp-1">{d.document.name}</span></td>
                                <td>{d.value.instrumentType}</td>
                                <td>{d.value.instrumentDate ? formatDate(d.value.instrumentDate) : ''}</td>
                                <td>{d.value.grantors.map(g => g.name).join('; ')}</td>
                                <td>{d.value.grantees.map(g => g.name).join('; ')}</td>
                            </tr>)}
                        </tbody>
                    </table>
                </div>
                <div className="flex justify-end p-4 mt-4 gap-2 border-t border-base-100">
                    <button className="btn btn-sm btn-outline btn-primary"
                        onClick={() => setTabIdx(null)}>Close</button>
                    <button className="btn btn-sm btn-primary"
                        onClick={() => {
                            addDocumentsToTab(tabIdx,
                                markedDocuments.map(md => filteredDocuments.find(d => d.id === md)))
                            setTabIdx(null)
                        }}>
                        Add to Tab
                    </button>
                </div>
            </div>
        </div>
    )
}

export default DocumentSelectionDialog